export default __webpack_public_path__ + "static/media/nutrilon_kinder.b073aabb.jpg";